import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=296b3e1c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=296b3e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b3e1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296b3e1c')) {
      api.createRecord('296b3e1c', component.options)
    } else {
      api.reload('296b3e1c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=296b3e1c&scoped=true&", function () {
      api.rerender('296b3e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25fBCgDQAMkcP/JS/comp/DocBox.vue"
export default component.exports